module.exports = __webpack_public_path__ + "static/2019_Poster_MarianeSchneider_Kyoto2019-12bc891f3aa212e763e910c49e8fac5a.pdf";